<template>
    <v-layout justify-center>
        <v-dialog v-model="show" max-width="600px">
            <v-card>
                <v-card-title class="pa-0 ma-0">
                    <v-toolbar dark color="blue lighten-2" class="titlebar">
                        <v-btn icon dark @click="show = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title>
                            Настройки для дат
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn text>Сохранить</v-btn>
                        </v-toolbar-items>
                    </v-toolbar>

                </v-card-title>
                <v-card-text class="content">
                    <v-container class="container-main mx-0 px-0" fluid>
                        <v-row>
                            <v-form
                                    ref="form"
                                    v-model="valid"
                            >
                                <v-row>
                                    <v-col cols="12" xs12 class="ma-0 px-3 py-0">
                                        <v-select
                                                :items="[ { text: 'Постоянный график', value: 1}, { text: 'Ручной график', value: 2 }]"
                                                class="ma-0 pa-0"
                                                v-model="deliveryScheduleModel.type"
                                                inset
                                                label="Тип Расписания:"
                                                item-value="value"
                                                item-text="text"
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="12" xs12 class="ma-0 px-3 py-0">
                                        <v-text-field
                                                label="Статус"
                                                required
                                                v-model="deliveryScheduleModel.status"
                                                class="ma-0 pa-0"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="6" xs12 class="ma-0 px-3 py-0">
                                        <v-text-field
                                                label="Начало действия расписания"
                                                type="date"
                                                v-model="deliveryScheduleModel.dateStart"
                                                class="ma-0 pa-0"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="6" xs12 class="ma-0 px-3 py-0">
                                        <v-text-field
                                                label="Конец действия расписания"
                                                type="date"
                                                v-model="deliveryScheduleModel.dateEnd"
                                                class="ma-0 pa-0"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col
                                            v-for="(timeIntervals, index) in timeIntervalsArray"
                                            :key="index"
                                            cols="12" xs12 class="ma-0 px-3 py-0"
                                    >
                                        <v-col cols="5" xs12 class="ma-0 px-3 py-0"
                                               v-if="!Array.isArray(timeIntervals)"
                                        >
                                            <v-text-field
                                                    label="Конец действия расписания"
                                                    type="time"
                                                    v-model="timeIntervalsArray[index]"
                                                    class="ma-0 pa-0"
                                            ></v-text-field>
                                        </v-col>
                                        <v-row :align="'center'">
                                            <v-col cols="2" xs12 class="ma-0 px-3 py-0">
                                                Интервал {{index + 1}}
                                            </v-col>
                                            <v-col cols="3" xs12 class="ma-0 px-3 py-0">
                                                <v-text-field
                                                        dense
                                                        solo
                                                        hide-details
                                                        v-if="Array.isArray(timeIntervals)"
                                                        type="time"
                                                        v-model="timeIntervalsArray[index][0]"
                                                        class="ma-0 pa-0"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="1" xs12 class="ma-0 px-3 py-0" :justify="'center'" :align="'center'">
                                                <v-icon>remove</v-icon>
                                            </v-col>
                                            <v-col cols="3" xs12 class="ma-0 px-3 py-0">
                                                <v-text-field
                                                        dense
                                                        solo
                                                        hide-details
                                                        v-if="Array.isArray(timeIntervals)"
                                                        type="time"
                                                        v-model="timeIntervalsArray[index][1]"
                                                        class="ma-0 pa-0"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col>
                                                <v-btn text color="primary" @click="addInterval">Добавить интервал<v-icon>add</v-icon></v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-col>

                                </v-row>
                            </v-form>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-snackbar
                v-model="paramsSnackbar.show"
                bottom
                :color="paramsSnackbar.color"
                right
        >
            {{paramsSnackbar.text}}
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
    </v-layout>
</template>

<script>
import timeHelpers from '../../../scripts/helpers/timeHelpers'
export default {
    name: 'DeliveryScheduleForm',
    data() {
        return {
            deliveryScheduleModel: {
                id: null,
                status: 1,
                type: 1, // 1 - выбранные дни в неделе, 2 - выходные дни
                dateStart: null,
                dateEnd: null,
                timeIntervals: '12-14:00',
                interval_type: 1, // 1 - auto intervals, 2 - select days (выбрать дни недели), 3 -ручной выбор полностью дат и времени (interval_hours ['12,14']; interval_days [1,2,3,4])
                interval_work_days_count: 2,
                interval_free_days_count: 2,
                interval_hours: '12-14:00',
                interval_week_days: null,
                interval_days: null,
                interval_months: null,
                interval_years: null,
                notification_admin: 1,
                notification_admin_times: null,
                notification_client: 1,
                notifications_client_times: null,
                vision_type: 1, // показывать на определённое количество от сегодняшнего дня
                vision_days_count: 2, // количество дней на которое показывать расписание
                free_days: null // праздничные дни и время которое исключается
            },
            paramsSnackbar: {
                text: '',
                color: '',
                show: false
            },
            show: false,
            valid: true
        }
    },
    props: ['visible'],
    components: {},
    computed: {
        timeIntervalsArray: {
            get() {
                if (this.deliveryScheduleModel.timeIntervals == null) {
                    return []
                }
                let array1 = this.deliveryScheduleModel.timeIntervals.split(',')
                let array2 = []
                for (let i = 0; i < array1.length; i++) {
                    array2[i] = timeHelpers.scheduleGetIntervalsByStr(array1[i])
                }
                return array2
            },
            set(value) {
                if (value.length === 0) {
                    this.deliveryScheduleModel.timeIntervals = null
                }
                for (let i = 0; i < value.length; i++) {

                }
            }
        }
    },
    methods: {
        addInterval() {

        }
    },
    watch: {
        visible: {
            handler(value) {
                value === true ? this.show = true : this.show = false
                if (value) {
                }
            },
            deep: true,
            immediate: true
        },
        show() {
            if (this.show === false) {
                this.$emit('close')
            }
        }
    },
    created() {

    }
}
</script>

<style scoped>

</style>
